import React from "react";
import { Icon } from "@iconify/react";

function ReturnIcon() {
  return (
    <div>
      <Icon icon="ion:return-down-back" width="18" height="18" />
    </div>
  );
}

export default ReturnIcon;
